import React, { useEffect, useState } from "react";

import callApi from "../../../../utility/apiCaller";

export default function LendingPartners() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const preferredOrder = [
      "Aditya Birla Finance Limited",
      "L&T",
      "Poonawalla",
      "UnityBank",
      "Hero Fincorp",
      "Kissht",
      "KreditBee",
      "Branch",
      "Incred",
    ];

    const fetchLenders = async () => {
      try {
        const [bucket1, bucket2] = await Promise.all([
          callApi("v1/lender/active-bucket1-lenders", "post", {}, "loan"),
          callApi("v1/lender/active-bucket2-lenders", "post", {}, "loan"),
        ]);

        const combined =
          bucket1?.status === "Success" && bucket2?.status === "Success"
            ? [...bucket1.data.lenderList, ...bucket2.data.lenderList]
            : [];

        const hardcodedLenders = [
          {
            name: "Aditya Birla Finance Limited",
            logo_image_url:
              "https://campaigns.digitmoney.in/image/partners/abc.png",
          },
          {
            name: "Incred",
            logo_image_url:
              "https://campaigns.digitmoney.in/image/partners/incred.png",
          },
          {
            name: "DMI",
            logo_image_url:
              "/assets/bank_img/DMI Size 2.png",
          },
        ];

        const merged = [...hardcodedLenders, ...combined];

        const ordered = [
          ...preferredOrder
            .map((name) => merged.find((l) => l.name === name))
            .filter(Boolean),
          ...merged.filter((l) => !preferredOrder.includes(l.name)),
        ];

        setPartners(ordered);
      } catch (error) {
        console.error("Error fetching lenders:", error);
      }
    };

    fetchLenders();
  }, []);

  return (
    <section className="w-full flex justify-center min-h-content items-center sm:pb-[100px] bg-black mx-auto py-16 px-6 sm:px-10">
      <div className="w-full max-w-7xl p-1 sm:p-5">
        <h2
          style={{ fontFamily: "myFirstFont7" }}
          className="[@media(max-width:340px)]:text-[25px] text-[30px] sm:text-[45px] md:text-[60px] text-white mb-10 [@media(max-width:340px)]:mb-5"
        >
          Our Lending Partners
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-5 gap-2 sm:gap-6">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="bg-[#111111] p-2  flex items-center justify-center rounded-md hover:bg-gray-800 transition duration-300"
            >
              <img
                src={partner.banking_partners || partner.logo_image_url}
                alt={partner.name}
                className="w-full  min-w-[120px] sm:min-w-[90%]  md:max-w-[160px] h-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
